<template>
    <div class="gmf-report-container">
        <div class="gmf-subheader">{{ t('title') }}</div>

        <div class="gmf-alert gmf-alert-info" v-if="hasReported && !error">
            {{ t('successful_report') }}
        </div>

        <div v-else-if="error" class="gmf-alert gmf-alert-error">
            {{ error }}
        </div>

        <p class="gmf-report-text">{{ t('text') }}</p>

        <div class="gmf-report-form">
            <TextArea v-model="text" cols="8" rows="10" :placeholder="t('write_additional_feedback')"></TextArea>
        </div>

        <button @click="report" class="gmf-report gmf-btn gmf-btn-sm gmf-btn-primary gmf-right">{{
            t('button') }}</button>
    </div>
</template>

<style>
.gmf-report.gmf-btn {
    margin-top: var(--gmf-p-4);
}

.gmf-report-container {
    max-width: 80vw;
    width: 500px;
}

.gmf-report-container .gmf-subheader {
    padding-bottom: var(--gmf-p-3);
}

.gmf-report-text {
    white-space: break-spaces;
    word-break: break-word;
}

.gmf-report-container textarea {
    border: 1px solid var(--gmf-col-gray) !important;
    outline: none !important;
    background: white;
    color: var(--gmf-col-nearblack);
    padding: 8px 12px;
    display: block;
    width: 100%;
    resize: none;
    overflow: hidden;
    border-radius: var(--gmf-rounding);
    font-size: 13px;
    font-family: unset;
}

.gmf-report-container textarea::placeholder {
    color: var(--gmf-col-darkgray);
}

.gmf-report-container textarea:focus {
    outline: none !important;
    border: 1px solid var(--gmf-col-gray) !important;
}
</style>

<script>
import TextArea from '@/components/input/TextArea.vue';
import callApi from '@/utils/callApi';

import state from '@/state';

const t = state.t.prefix('report');

export default {
    components: {
        TextArea,
    },

    inject: ['closeModal'],

    data() {
        return {
            comment: null,
            text: '',
            hasReported: false,
            error: null,
            isLoading: false,
        }
    },

    methods: {
        t,

        async report() {
            if (!this.comment) {
                this.closeModal();
            }

            if (!this.text) {
                this.error = this.t('error.no_text');
                return;
            }

            try {
                this.isLoading = true;

                const res = await callApi('POST', `/v1/reports/${this.comment.id}`, {
                    comment: this.text,
                });

                const body = await res.json();

                if (res.status !== 200 && body.error && body.error.code) {                    
                    if (body.error.code === 104504) {
                        this.error = this.t('error.already_reported');
                    } else if (body.error.code === 104503) {
                        this.error = this.t('error.self_reporting_not_permitted');
                    }

                    return;
                }

                this.hasReported = true;
            } finally {
                this.isLoading = false;
            }
        },

        setComment(c) {
            this.comment = c;
        }
    }
}
</script>
